import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import { makeObservable, observable, reaction, computed, runInAction, action } from "mobx";
import { handle, ERRORS } from "@dp/common";
import Base from "./Base";
import DPServices from "@dp/services";
import { OnlinePaymentTypes, PaymentFlow, PaymentMethods } from "../utils";
var GCCheckout = (_class = /*#__PURE__*/function (_Base) {
  _inherits(GCCheckout, _Base);

  var _super = _createSuper(GCCheckout); //Add all models for checkout here.


  function GCCheckout(rootStore) {
    var _this;

    _classCallCheck(this, GCCheckout);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "rootStore", void 0);

    _initializerDefineProperty(_assertThisInitialized(_this), "cartOrder", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "formState", _descriptor2, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "payment", null);

    _initializerDefineProperty(_assertThisInitialized(_this), "appAttributes", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "gcsessionAttributes", _descriptor4, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "appMessages", null);

    _this.rootStore = rootStore;
    _this.payment = rootStore.payment;
    _this.formState = {
      submitCount: 0,
      apiFiredCount: 0,
      isFailed: false,
      isSubmitting: false,
      isSuccess: false
    };
    makeObservable(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(GCCheckout, [{
    key: "reset",
    value: function reset() {
      return null;
    }
  }, {
    key: "setupReactions",
    value: function setupReactions() {
      var _this2 = this; //app-init


      reaction(function () {
        return {
          appAttributes: _this2.rootStore.common.appAttributes
        };
      }, function (data) {
        _this2._processAppAttributes(data.appAttributes);
      });
      reaction(function () {
        return {
          submitCount: _this2.formState.submitCount
        };
      }, function (data) {
        var isSubmitted = data.submitCount > 0;
        _this2.payment.formSubmitted = isSubmitted;
      });
    }
  }, {
    key: "_processAppAttributes",
    value: function _processAppAttributes(appAttributes) {
      this.appAttributes = appAttributes;
      this.payment.creditCardInfo.fullAVSEnabled = true;
      this.payment.creditCardInfo.fullAVSEnabledMandate = true;
    }
  }, {
    key: "_processCartResponse",
    value: function () {
      var _processCartResponse2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(order) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (order) {
                  this.payment.orderPriceInfo = order === null || order === void 0 ? void 0 : order.priceInfo;
                  this.payment.tippableAmount = order === null || order === void 0 ? void 0 : order.tippableAmount;
                  this.cartOrder = order;
                  this.payment.subTotalWithoutItemDiscount = order.subTotalWithoutItemDiscount;
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _processCartResponse(_x) {
        return _processCartResponse2.apply(this, arguments);
      }

      return _processCartResponse;
    }()
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this3 = this;

        var isLoggedIn, _yield$handle, _yield$handle2, err, gcsessionAttributes, _yield$handle3, _yield$handle4, cartDetailsErr, cartDetailsResponse;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.payment.flow = PaymentFlow.GC_CHECKOUT;
                this.payment = this.rootStore.payment;
                this.appMessages = this.rootStore.appMessages;
                this.payment.isGooglePayEnabled = false;
                this.payment.isApplePayEnabled = false;
                this.payment.isPayPalEnabled = false;
                this.payment.isGiftCardPaymentEnabled = false; //IMPORTANT: common store is already initialized before Checkout store

                this._processAppAttributes(this.rootStore.common.appAttributes);

                isLoggedIn = this.rootStore.user.isLoggedIn;

                if (isLoggedIn) {
                  this.payment.activeOtherOptionTab = OnlinePaymentTypes.NONE;
                } else {
                  this.payment.activeOtherOptionTab = OnlinePaymentTypes.CREDIT_CARD;
                } //sessioninit api


                _context3.next = 12;
                return handle(DPServices.Common.getGiftCardSessionAttributes());

              case 12:
                _yield$handle = _context3.sent;
                _yield$handle2 = _slicedToArray(_yield$handle, 2);
                err = _yield$handle2[0];
                gcsessionAttributes = _yield$handle2[1];

                if (err) {
                  this.appMessages.showError("Checkout", "Invalid State. Please Go Back.", null, {
                    undismissible: true,
                    okBtnText: "Go Back",
                    okBtnOnClick: function okBtnOnClick() {
                      _this3.redirectToGiftCardPage();
                    }
                  });
                } else {
                  if (gcsessionAttributes) {
                    runInAction(function () {
                      _this3.gcsessionAttributes = gcsessionAttributes;

                      if (gcsessionAttributes.orderLockedForFraudSuspicion || gcsessionAttributes.dardenSessionContext.orderLockedForFraudSuspicion) {
                        _this3.payment.isCCPaymentDisabled = true;
                      }
                    });
                  }
                }

                _context3.next = 19;
                return handle(DPServices.Cart.getCartDetails());

              case 19:
                _yield$handle3 = _context3.sent;
                _yield$handle4 = _slicedToArray(_yield$handle3, 2);
                cartDetailsErr = _yield$handle4[0];
                cartDetailsResponse = _yield$handle4[1];

                if (cartDetailsErr) {
                  this.appMessages.showError("Cart", "Invalid State. Please Go Back.", null, {
                    undismissible: true,
                    okBtnText: "Go Back",
                    okBtnOnClick: function okBtnOnClick() {
                      _this3.redirectToGiftCardPage();
                    }
                  });
                } else {
                  runInAction( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                    var _cartDetailsResponse$;

                    var order;
                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            order = cartDetailsResponse === null || cartDetailsResponse === void 0 ? void 0 : (_cartDetailsResponse$ = cartDetailsResponse.successResponse) === null || _cartDetailsResponse$ === void 0 ? void 0 : _cartDetailsResponse$.order;

                            if (order) {
                              _this3._processCartResponse(order);
                            }

                          case 2:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  })));
                }

              case 24:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "redirectToGiftCardPage",
    value: function redirectToGiftCardPage() {
      var _this$gcsessionAttrib;

      if ((_this$gcsessionAttrib = this.gcsessionAttributes) !== null && _this$gcsessionAttrib !== void 0 && _this$gcsessionAttrib.giftCardURL) {
        this.rootStore.refreshInProgress = true;
        this.rootStore.platformUtil.redirectToURL(this.gcsessionAttributes.giftCardURL);
      } else {
        this.rootStore.refreshInProgress = true;
        this.rootStore.platformUtil.redirectToURL("/gift-cards");
      }
    }
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "validateSubmitOrder",
    value: function validateSubmitOrder() {
      if (!this.isValid) {
        var payment = this.payment;
        this.formState.submitCount = this.formState.submitCount + 1;
        this.rootStore.common.accordionModel.setFormSubmitted();

        if (!payment.isValid) {
          payment.handleInvalidModel(this.appMessages, this.rootStore.isMobile);
          return false;
        }

        return false;
      } else {
        return true;
      }
    }
  }, {
    key: "submitOrder",
    value: function () {
      var _submitOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(paymentAlreadyProcessed) {
        var _this4 = this;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", new Promise(function (resolve) {
                  runInAction( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                    var valid, orderName, processingError, gcSubmitOrderRequest, dfpSessionId, canProceedWithSubmitOrder, orderTotal, activePaymentTab, activePaymentOptionTab, savedCCPayment, merchantId, _yield$handle5, _yield$handle6, error, _merchantId, _yield$handle7, _yield$handle8, _error, ccFormPayment, submitOrderResult, _DPServices$Cart$pars, result, faults, sessionExpiredFaults, paymentServiceFaults, paymentServiceFault;

                    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            valid = _this4.validateSubmitOrder();
                            orderName = "Order Name " + _this4.cartOrder.orderId;
                            processingError = null;

                            if (!valid) {
                              _context5.next = 79;
                              break;
                            }

                            _context5.prev = 4;
                            _this4.formState.apiFiredCount = _this4.formState.apiFiredCount + 1;
                            _this4.formState.isSubmitting = true;
                            gcSubmitOrderRequest = {
                              paymentAlreadyProcessed: paymentAlreadyProcessed ? true : false,
                              // rsaFlowEnabled: this.payment.rsaFlowEnabled,
                              orderName: orderName,
                              payments: []
                            };
                            _context5.next = 10;
                            return _this4.rootStore.platformUtil.getDFPSessionId();

                          case 10:
                            dfpSessionId = _context5.sent;

                            if (dfpSessionId) {
                              gcSubmitOrderRequest.bamsCorrelationId = dfpSessionId;
                            }

                            canProceedWithSubmitOrder = true;
                            orderTotal = _this4.payment.orderTotalIncludingGratuity;

                            if (!(orderTotal > 0)) {
                              _context5.next = 51;
                              break;
                            }

                            activePaymentTab = _this4.payment.activePaymentTab;
                            activePaymentOptionTab = _this4.payment.activeOtherOptionTab;

                            if (!(activePaymentTab === PaymentMethods.ONLINE)) {
                              _context5.next = 47;
                              break;
                            }

                            if (!_this4.payment.isSavedCreditCardSelected) {
                              _context5.next = 31;
                              break;
                            } // // Saved Credit Card selected


                            savedCCPayment = _this4.payment.savedCCPaymentPayload;

                            if (!(savedCCPayment.creditCard.paymentCVV && _this4.payment.rsaFlowEnabled)) {
                              _context5.next = 28;
                              break;
                            } // CVV validation Callout for RSA flow only
                            // Always use Partial MID for CVV CORS request


                            merchantId = _this4.gcsessionAttributes.partialAVSmerchantID;
                            _context5.next = 24;
                            return handle(_this4.payment.validateSecurityCode(_this4.gcsessionAttributes.paymentCorrelationId, _this4.cartOrder.orderId, "GIFTCARD", savedCCPayment, merchantId));

                          case 24:
                            _yield$handle5 = _context5.sent;
                            _yield$handle6 = _slicedToArray(_yield$handle5, 1);
                            error = _yield$handle6[0];

                            if (error) {
                              processingError = error;
                              canProceedWithSubmitOrder = false;
                            }

                          case 28:
                            gcSubmitOrderRequest.payments.push(savedCCPayment);
                            _context5.next = 45;
                            break;

                          case 31:
                            if (!(activePaymentOptionTab === OnlinePaymentTypes.CREDIT_CARD)) {
                              _context5.next = 45;
                              break;
                            }

                            if (!_this4.payment.creditCardInfo.isValid) {
                              _context5.next = 44;
                              break;
                            }

                            if (_this4.payment.creditCardInfo.paymentToken) {
                              _context5.next = 41;
                              break;
                            }

                            _merchantId = _this4.payment.creditCardInfo.fullAVSEnabled ? _this4.gcsessionAttributes.fullAVSmerchantID : _this4.gcsessionAttributes.partialAVSmerchantID;
                            _context5.next = 37;
                            return handle(_this4.payment.tokenizeCreditCardPayment(_merchantId, _this4.gcsessionAttributes.paymentCorrelationId, _this4.cartOrder.orderId, "GIFTCARD"));

                          case 37:
                            _yield$handle7 = _context5.sent;
                            _yield$handle8 = _slicedToArray(_yield$handle7, 1);
                            _error = _yield$handle8[0];

                            if (_error) {
                              processingError = _error;
                            }

                          case 41:
                            if (!_this4.payment.creditCardInfo.isCCError) {
                              ccFormPayment = _this4.payment.formCCPaymentPayload;
                              gcSubmitOrderRequest.payments.push(ccFormPayment);
                            } else {
                              canProceedWithSubmitOrder = false;
                            }

                            _context5.next = 45;
                            break;

                          case 44:
                            canProceedWithSubmitOrder = false;

                          case 45:
                            _context5.next = 49;
                            break;

                          case 47:
                            canProceedWithSubmitOrder = false;
                            processingError = ERRORS.PAY_AT_RESTAURANT_NOT_SUPPORTED;

                          case 49:
                            _context5.next = 53;
                            break;

                          case 51:
                            canProceedWithSubmitOrder = false;
                            processingError = ERRORS.INVALID_ORDER_TOTAL;

                          case 53:
                            if (!canProceedWithSubmitOrder) {
                              _context5.next = 60;
                              break;
                            }

                            _context5.next = 56;
                            return DPServices.Cart.giftCardSubmitOrder(_this4.cartOrder.orderId, gcSubmitOrderRequest);

                          case 56:
                            resolve({
                              status: "SUCCESS"
                            });

                            _this4.redirectToConfirmationPage();

                            _context5.next = 66;
                            break;

                          case 60:
                            _this4.formState.isSubmitting = false;
                            _this4.formState.isFailed = true;
                            submitOrderResult = {
                              status: "ERROR"
                            };

                            if (processingError) {
                              submitOrderResult.faultCode = "CC_PROCESSING_ERROR";

                              if (processingError === ERRORS.CC_TOKENIZATION_BUSINESS_FAULT) {
                                _this4.appMessages.showError("Credit Card", "Sorry, we're unable to process your request. Please verify card details and re-try or use a different card.");
                              }

                              if (processingError === ERRORS.PAY_AT_RESTAURANT_NOT_SUPPORTED || processingError === ERRORS.INVALID_ORDER_TOTAL) {
                                _this4.appMessages.showError("Checkout", "Unable to proceed with order submission. Please try again.");
                              }

                              if (processingError === ERRORS.CC_TOKENIZATION_TECHNICAL_FAILURE || processingError === ERRORS.ORDER_SESSION_TOKEN_FAILURE) {
                                _this4.appMessages.showError("Credit Card", "Sorry, we're unable to process your request. Please verify card details and re-try or use a different card.");
                              } else if (processingError === ERRORS.CVV_VALIDATION_ERROR) {
                                _this4.appMessages.showError("CVV validation", "Sorry, we're unable to process your request. Please verify your Security Code and re-try or use a different card.");
                              } else {
                                submitOrderResult.faultCode = "PAYMENT_PROCESSING_ERROR";

                                _this4.appMessages.showError("Checkout", "Cannot proceed with order submission. Please try again.");
                              }
                            } else {
                              submitOrderResult.faultCode = "PAYMENT_PROCESSING_ERROR";

                              _this4.appMessages.showError("Checkout", "Cannot proceed with order submission. Please try again.");
                            } // analytics submit order failed event


                            _this4.analyticsFailedSubmitOrderEvent();

                            resolve(submitOrderResult);

                          case 66:
                            _context5.next = 77;
                            break;

                          case 68:
                            _context5.prev = 68;
                            _context5.t0 = _context5["catch"](4);
                            result = {
                              status: "ERROR"
                            };
                            faults = (_DPServices$Cart$pars = DPServices.Cart.parseErrors(_context5.t0)) === null || _DPServices$Cart$pars === void 0 ? void 0 : _DPServices$Cart$pars.faults;

                            if (faults) {
                              sessionExpiredFaults = faults.filter(function (fault) {
                                return fault.faultCode === "sessionExpired" || fault.faultCode === "SubmitOrderFail";
                              });

                              if (sessionExpiredFaults.length > 0) {
                                sessionExpiredFaults.forEach(function (fault) {
                                  if (fault.faultCode === "sessionExpired") {
                                    result.faultCode = fault.faultCode;
                                    result.reason = fault.faultDescription;

                                    _this4.appMessages.showError("Session Expired", "Your session has expired due to an extended period of inactivity.", null, {
                                      undismissible: true,
                                      okBtnText: "Ok",
                                      okBtnOnClick: function okBtnOnClick() {
                                        _this4.redirectToGiftCardPage();
                                      }
                                    });
                                  }

                                  if (fault.faultCode === "SubmitOrderFail") {
                                    result.faultCode = fault.faultCode;
                                    result.reason = fault.faultDescription;

                                    _this4.appMessages.showError("Failed", "Failed to submit order. Please re-try.", null, {
                                      undismissible: true,
                                      okBtnText: "Go Back",
                                      okBtnOnClick: function okBtnOnClick() {
                                        _this4.redirectToGiftCardPage();
                                      }
                                    });
                                  }
                                });
                              } else {
                                paymentServiceFaults = faults.filter(function (fault) {
                                  return fault.faultCode.indexOf("PaymentService-") === 0;
                                });

                                if (paymentServiceFaults.length > 0) {
                                  paymentServiceFault = paymentServiceFaults[0];
                                  result.faultCode = paymentServiceFault.faultCode;
                                  result.reason = paymentServiceFault.faultDescription;
                                } else {
                                  result.faultCode = "ORDER_PROCESSING_ERROR";

                                  _this4.appMessages.showErrorMessage("Failed", _context5.t0);
                                }
                              }
                            } else {
                              result.faultCode = "ORDER_PROCESSING_ERROR";

                              _this4.appMessages.showError("Error", "Unable to proceed with order submission. Please try again.");
                            }

                            _this4.formState.isSubmitting = false;
                            _this4.formState.isFailed = true; // analytics submit order failed event

                            _this4.analyticsFailedSubmitOrderEvent();

                            resolve(result);

                          case 77:
                            _context5.next = 82;
                            break;

                          case 79:
                            _this4.formState.isSubmitting = false;

                            _this4.analyticsFailedSubmitOrderEvent();

                            resolve({
                              status: "ERROR",
                              faultCode: "FORM_INVALID"
                            });

                          case 82:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5, null, [[4, 68]]);
                  })));
                }));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function submitOrder(_x2) {
        return _submitOrder.apply(this, arguments);
      }

      return submitOrder;
    }()
  }, {
    key: "analyticsFailedSubmitOrderEvent",
    value: function analyticsFailedSubmitOrderEvent() {
      this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "Payment", {
        success: false
      });
    }
  }, {
    key: "redirectToConfirmationPage",
    value: function redirectToConfirmationPage() {
      var _this5 = this;

      this.rootStore.refreshInProgress = true;
      this.rootStore.platformUtil.clearSessionStorage().then(function () {
        _this5.rootStore.platformUtil.redirectToURL("/purchase/gift-card-order-confirmation");
      }, function () {
        _this5.rootStore.platformUtil.redirectToURL("/purchase/gift-card-order-confirmation");
      });
    }
  }, {
    key: "isValid",
    get: function get() {
      var payment = this.payment;
      return payment.isValid;
    }
  }]);

  return GCCheckout;
}(Base), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "cartOrder", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "formState", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "gcsessionAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "_processAppAttributes", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_processAppAttributes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isValid"), _class.prototype)), _class);
export { GCCheckout as default };